module.exports = __webpack_public_path__ + "img/img_bata.e9ce0c7a.svg";